module.exports = __webpack_public_path__ + "img/astroCalendar_large.8e5e7f63.svg";